export default "__VITE_ASSET__CqTzSCWg__"